export const environment = {
  production: false,
  // apiUrl: 'https://localhost:5001/api/en',
  // fileServerUrl: 'https://localhost:5001/',
  // apiFileServerUrl: 'https://localhost:5001/api',
  // notificationHubUrl: 'https://localhost:5001/notification',
  // frontendUrl: 'http://localhost:4200',

  apiUrl: 'https://pactechportal.azurewebsites.net/api/en',
  apiFileServerUrl: 'https://pactechportal.azurewebsites.net/api',
  fileServerUrl: 'https://pactechportal.azurewebsites.net/',
  notificationHubUrl: 'https://pactechportal.azurewebsites.net/notification',
  frontendUrl: 'https://login.pactech.ca',

  // apiUrl: 'http://130.185.73.32:1013/api/en',
  // fileServerUrl: 'http://130.185.73.32:1013/',
  // apiFileServerUrl: 'http://130.185.73.32:1013/api',
  // notificationHubUrl: 'http://130.185.73.32:1013/notification',


  // apiUrl: 'https://pactechportal.azurewebsites.net/api/en',
  // apiFileServerUrl: 'https://pactechportal.azurewebsites.net/api',
  // fileServerUrl: 'https://pactechportal.azurewebsites.net/',
  // notificationHubUrl: 'https://pactechportal.azurewebsites.net/notification',

  logoPath: '/assets/images/logo.svg',
  logoBlackPath: '/assets/images/logo-text-black.svg',
  logoWhitePath: '/assets/images/logo-text-white.svg',

  defaultAvatar: '/assets/Icons/user-avatar.svg',
};
